import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading, HStack, Text } from '@library';
import Container from '../../../core/components/Container';
import LinkBreadcrumbs from '../../../core/components/LinkBreadcrumbs';
import useNewsArchive from '../../hooks/useNewsArchive';
import { FluidProgressIndicator } from '../../../core/components/ProgressIndicators';
import Button from '../../../core/components/Button';
import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import PostsList from './PostsList';
import PostsFilters from './PostFilters/PostsFilters';
import styles from './PostsPage.module.scss';

const PostsPage = memo(() => {
    const breadcrumbs = [
        { labelId: 'news archive', to: '.', isRelative: true },
    ];

    const { data, fetchMore, loading, changeFilters, filters } =
        useNewsArchive();

    const isMore = data.total > data.items.length && !loading;

    return (
        <div>
            <LinkBreadcrumbs titleId="news archive" breadcrumbs={breadcrumbs} />
            <Container>
                <div className={styles.container}>
                    <div className={styles.header}>
                        <Heading h3>
                            <FormattedMessage id="news archive" />
                        </Heading>
                    </div>
                    <HStack wrap gap="small">
                        <div className={styles.filters}>
                            <PostsFilters
                                filters={filters}
                                changeFilters={changeFilters}
                            />
                        </div>
                        <div className={styles.list}>
                            <div className={styles.subHeader}>
                                <Text primary medium uppercase>
                                    <FormattedMessage id="recently published" />
                                </Text>
                            </div>
                            <PostsList items={data.items} />

                            {loading && (
                                <div className={styles.progress}>
                                    <FluidProgressIndicator />
                                </div>
                            )}

                            <div className={styles.showMoreButton}>
                                {isMore && (
                                    <Button
                                        noPadding
                                        textOnlySecondary
                                        onPress={async () => {
                                            await fetchMore();
                                        }}
                                    >
                                        + <FormattedMessage id="show more" />
                                    </Button>
                                )}
                            </div>
                        </div>
                    </HStack>
                </div>
            </Container>
        </div>
    );
});

export default memo(
    withErrorBoundary(PostsPage, {
        errorComponent: ({ defaultErrorMessage }) => {
            const breadcrumbs = [
                { labelId: 'news archive', to: '.', isRelative: true },
            ];

            return (
                <div>
                    <LinkBreadcrumbs
                        titleId="news archive"
                        breadcrumbs={breadcrumbs}
                    />
                    <Container>
                        <div className={styles.container}>
                            <div className={styles.header}>
                                <Heading h3>
                                    <FormattedMessage id="news archive" />
                                </Heading>
                            </div>
                            {defaultErrorMessage}
                        </div>
                    </Container>
                </div>
            );
        },
    })
);
